import React, { useState, useEffect } from 'react';
 import API from '../Services/AddPackage'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const AddWaiver = () => {
    const options = ['Adult', 'Adult + Kids', 'Kids Only'];
    // console.log('Waiverlength', Waiverlength)
    const [Waiverlength,SetWaiverlength]=useState(5);
    const [selected, setSelected] = useState(options[0]);
    const [showTable, setShowTable] = useState(false);
    const [showChildModal, setShowChildModal] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    // const img = require("../../assets/FRSPhotoIcon.png")
    const [customer_id, setCustomerId] = useState("");
    const [numForms, setNumForms] = useState(Waiverlength);
    const [forms, setForms] = useState([{ id: Date.now(), isOtpVerified: false }]);
    const [childForms, setChildForms] = useState([{ id: Date.now(), isOtpVerified: otpVerified }]);
    const [errors, setErrors] = useState({});
    const [otpSentStatus, setOtpSentStatus] = useState({});
    const [childErrors, setChildErrors] = useState({})
    const [waiverData, setWaiverData] = useState([]);
    const [waiverFilled, setWaiverFilled] = useState(0)
    const [selectedWaiverEntry, setSelectedWaiverEntry] = useState(null);
    const [enable, setEnable] = useState(true)
    const [savedWaiver, setSavedWaiver] = useState([])
    const [otpTimers, setOtpTimers] = useState({ kidsOnly: 0 });
    const [resendEnabled, setResendEnabled] = useState({ kidsOnly: true });


    useEffect(() => {
        setNumForms(Waiverlength)
    }, [Waiverlength])

    const validateFormFields = () => {
        let adultErrors = {};
        let kidErrors = {};
        let kidsOnlyErrors = {};

        if (selected === 'Adult') {
            forms.forEach((form, index) => {
                const age = calculateAge(form.dob);

                if (!form.firstName) {
                    adultErrors[`firstName_${index}`] = "First name is required.";
                }
                if (!form.lastName) {
                    adultErrors[`lastName_${index}`] = "Last name is required.";
                }
                if (!form.dob) {
                    adultErrors[`dob_${index}`] = "Date of birth is required.";
                } else if (age < 18) {
                    adultErrors[`dob_${index}`] = "Age must be 18 or above.";
                }
                if (!form.gender) {
                    adultErrors[`gender_${index}`] = "Gender is required.";
                }
            });

            setErrors(adultErrors);
            return adultErrors;
        }

        if (selected === 'Adult + Kids') {
            let hasValidAdult = false;

            forms.forEach((form, index) => {
                const age = calculateAge(form.dob);

                if (!form.firstName) {
                    adultErrors[`firstName_${index}`] = "First name is required.";
                }
                if (!form.lastName) {
                    adultErrors[`lastName_${index}`] = "Last name is required.";
                }
                if (!form.dob) {
                    adultErrors[`dob_${index}`] = "Date of birth is required.";
                } else if (age >= 18) {
                    hasValidAdult = true;
                } else {
                    adultErrors[`dob_${index}`] = "Adult must be at least 18 years old.";
                }
                if (!form.gender) {
                    adultErrors[`gender_${index}`] = "Gender is required.";
                }
            });

            if (!hasValidAdult) {
                toast.error("At least one adult must be 18 or older.");
            }

            childForms.forEach((form, index) => {
                const age = calculateAge(form.dob);

                if (!form.firstName) {
                    kidErrors[`firstName_${index}`] = "Required.";
                }
                if (!form.lastName) {
                    kidErrors[`lastName_${index}`] = "Required.";
                }
                if (!form.dob) {
                    kidErrors[`childDob_${index}`] = "Required.";
                } else if (age >= 18) {
                    kidErrors[`childDob_${index}`] = "Child age must be below 18.";
                }
                if (!form.gender) {
                    kidErrors[`gender_${index}`] = "Required.";
                }
            });

            setErrors(adultErrors);
            setChildErrors(kidErrors);
            return { ...adultErrors, ...kidErrors };
        }

        if (selected === 'Kids Only') {
            childForms.forEach((form, index) => {
                const age = calculateAge(form.dob);

                if (!form.firstName) {
                    kidsOnlyErrors[`firstName_${index}`] = "First name is required.";
                }
                if (!form.lastName) {
                    kidsOnlyErrors[`lastName_${index}`] = "Last name is required.";
                }
                if (!form.dob) {
                    kidsOnlyErrors[`dob_${index}`] = "Date of birth is required.";
                } else if (age >= 18) {
                    kidsOnlyErrors[`dob_${index}`] = "Child must be below 18 years old.";
                }
                if (!form.gender) {
                    kidsOnlyErrors[`gender_${index}`] = "Gender is required.";
                }
            });

            setChildErrors(kidsOnlyErrors);
            return kidsOnlyErrors;
            
        }

        return {};
    };


    const handleSubmit = async () => {
        const errs = validateFormFields();
        if (Object.keys(errs).length > 0) return;
        if (!otpVerified) {
            toast.error("Please verify phone number");
            return
        }
        console.log('form', forms);
        const payload = {
            customer_id: customer_id,
            data: forms.map(({ ...rest }) => rest)
        };
        handlePostData(payload)
    };

    const handleAdultKidSubmit = async () => {
        const errs = validateFormFields();
        if (Object.keys(errs).length > 0) return;
        if (!otpVerified) {
            toast.error("Please verify phone number");
            return
        }
        console.log('form', forms);
        const payload = {
            customer_id: customer_id,
            data: [
                ...forms.map(({ isOtpVerified, ...rest }) => ({
                    ...rest,
                    isOtpVerified
                })),
                ...childForms.map(({ isOtpVerified, ...rest }) => ({
                    ...rest,
                    isOtpVerified: otpVerified,
                    mobile: forms?.[0].mobile,
                    otp: ""
                }))
            ]
        };
        console.log("payload data...", payload)
        handlePostData(payload);
    };



    const handleKidsSubmit = () => {
        const errs = validateFormFields();
        if (Object.keys(errs).length > 0) return;
        if (!otpVerified) {
            toast.error("Please verify phone number");
            return
        }
        console.log('form', forms);
        const payload = {
            customer_id: customer_id,
            data: [
                ...childForms.map(({ isOtpVerified, ...rest }) => ({
                    ...rest,
                    isOtpVerified: otpVerified,
                    mobile: kidsOnlyParent.mobile,
                    otp: ""
                }))
            ]
        };
        console.log("payload data...", payload)
        handlePostData(payload);
    }



    const handlePostData = async (payload) => {
        const incomingCount = payload?.data?.length || 0;

        if (waiverFilled + incomingCount > Waiverlength) {
            toast.error(`You can only fill a maximum of ${Waiverlength} waiver${Waiverlength > 1 ? 's' : ''}.`);
            return;
        }

        try {
            const response = await API.AddWaiver(payload);

            if (response.status === 200) {
                toast.success(response.data.message);

                const formattedData = payload.data.map((item) => ({
                    id: item.id,
                    name: `${item.firstName} ${item.lastName}`,
                    dob: item.dob,
                    gender: item.gender,
                }));

                setSavedWaiver(prev => [...prev, ...formattedData]);
                setShowTable(true);

                setWaiverFilled(prev => {
                    const updated = prev + incomingCount;
                    if (updated === Waiverlength) {
                        setEnable(false);
                    }
                    return updated;
                });

                setChildForms([{ id: Date.now(), isOtpVerified: false }]);
                setForms([{ id: Date.now(), isOtpVerified: false }]);
                setErrors({});
                setChildErrors({});

                // ✅ Only reset if not in 'Kids Only'
                setOtpVerified(prev => selected !== 'Kids Only' ? false : prev);

                setCustomerId("");
                setOtpSentStatus({});

            } else {
                toast.error(response.data.message || "Failed to submit waiver.");
            }
        } catch (error) {
            toast.error("Something went wrong.");
            console.error("handlePostData error:", error);
        }
    };

    const handleAddChildRow = () => {
        setChildForms(prev => [...prev, { id: Date.now(), isOtpVerified: otpVerified }]);
    };

    const handleInputChange = (id, field, value) => {
        setForms((prevForms) =>
            prevForms.map((form) =>
                form.id === id ? { ...form, [field]: value } : form
            )
        );
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            const index = forms.findIndex(f => f.id === id);
            delete updatedErrors[`${field}_${index}`];
            return updatedErrors;
        });
    };

    const handleChildInput = (id, field, value) => {
        setChildForms((prevForms) =>
            prevForms.map((form) =>
                form.id === id ? { ...form, [field]: value } : form
            )
        );

        setChildErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            const index = childForms.findIndex(f => f.id === id);
            const key = field === 'dob' ? `dob_${index}` : `${field}_${index}`;
            delete updatedErrors[key];
            return updatedErrors;
        });
    };

    const handleSendOtp = async (mobile, id) => {
        try {
            const response = await API.SendOtp(mobile);
            if (response.status === 200) {
                toast.success(response.data.message);
                setCustomerId(response.data.data.customer_id);
                setOtpSentStatus(prev => ({ ...prev, [id]: true }));

                let countdown = 20;

                // Immediately disable resend and start timer
                setResendEnabled(prev => ({ ...prev, [id]: false }));
                setOtpTimers(prev => ({ ...prev, [id]: countdown }));

                const interval = setInterval(() => {
                    countdown -= 1;
                    setOtpTimers(prev => {
                        const updated = { ...prev, [id]: countdown };
                        return updated;
                    });

                    if (countdown <= 0) {
                        clearInterval(interval);
                        setResendEnabled(prev => ({ ...prev, [id]: true }));
                    }
                }, 1000);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("An error occurred while sending OTP.");
        }
    };


    const handleVerifyOtp = async (formId, otpValue) => {
        if (otpValue.length !== 6) {
            toast.error("Please enter a valid 6-digit OTP.");
            return;
        }

        const form = forms.find(f => f.id === formId);
        if (!form || !form.mobile) {
            toast.error("Mobile number not found.");
            return;
        }
        const payload = { mobile: form.mobile, otp: otpValue };
        try {
            const response = await API.VerifyOtp(payload);
            if (response.data.success) {
                setOtpVerified(true);
                getWaiverData(form?.mobile)
                toast.success("OTP Verified Successfully");
                setForms(prevForms =>
                    prevForms.map(f =>
                        f.id === formId ? { ...f, isOtpVerified: true, otp: '' } : f
                    )
                );
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "OTP verification failed.");
        }
    };




    const [kidsOnlyParent, setKidsOnlyParent] = useState({
        mobile: '',
        otp: '',
        isOtpVerified: false,
    });

    const handleVerifyOtpForKidsOnly = async () => {
        const { mobile, otp } = kidsOnlyParent;
        if (!mobile || otp.length !== 6) {
            toast.error("Please enter a valid mobile and 6-digit OTP.");
            return;
        }

        const payload = { mobile, otp };
        try {
            const response = await API.VerifyOtp(payload);
            if (response.data.success) {
                getWaiverData(mobile);
                setOtpVerified(true); // ✅ controls form visibility
                toast.success("OTP Verified Successfully");

                setKidsOnlyParent(prev => ({
                    ...prev,
                    isOtpVerified: true,
                    otp: ''
                }));

                // ✅ Don't reset selected here
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("OTP verification failed.");
        }
    };



    const handleKidsOnlyParentChange = (field, value) => {
        setKidsOnlyParent(prev => ({ ...prev, [field]: value }));
    };


    const get18YearsAgoDate = () => {
        const today = new Date();
        today.setFullYear(today.getFullYear() - 18);
        return today.toISOString().split('T')[0];
    };


    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };



    const getAge = (dob) => {
        const birthDate = new Date(dob);
        const ageDifMs = Date.now() - birthDate.getTime();
        const ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    };

    const calculateAge = (dob) => {
        if (!dob) return 0;
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };



    const getWaiverData = async (mobile) => {
        try {
            const response = await API.getWaiver(mobile);
            if (response?.status === 200 && response?.data?.data) {
                const allData = response.data.data;
                console.log(".......", allData)
                const adults = allData.filter(person => getAge(person.date_of_birth) >= 18);
                console.log("adults...", adults)
                const kids = allData.filter(person => getAge(person.date_of_birth) < 18);
                console.log("✅ Adults:", adults);
                console.log("👶 Kids:", selected === 'Kids Only' ? kids : adults);
                setWaiverData(selected === 'Kids Only' ? kids : selected === 'Adult + Kids' ? allData : adults);
                setShowTable(true);
            } else {
                toast.error("Failed to fetch previous waiver data");
            }
        } catch (error) {
            // toast.error("Error fetching waiver data");
            console.error("Waiver fetch error:", error);
        }
    };


    const handleCheckboxChange = (entry) => {
        const isAlreadySelected = selectedWaiverEntry?.id === entry.id;
        if (isAlreadySelected) {
            setSelectedWaiverEntry(null);
            setForms([{ id: Date.now(), isOtpVerified: false }]);
            setChildForms([{ id: Date.now(), isOtpVerified: false }]);
        } else {
            setSelectedWaiverEntry(entry);
            fillFormWithSelectedWaiver(entry);
        }
    };


    const handleSelect = (option) => {
        setSelected(option);
        // setShowTable(false);
        if (selectedWaiverEntry) {
            fillFormWithSelectedWaiver(selectedWaiverEntry);
        }
    };


    const fillFormWithSelectedWaiver = (entry) => {
        const age = getAge(entry.date_of_birth);
        const [firstName = '', lastName = ''] = entry.name?.split(' ') || [entry.name, ''];
        const filledData = {
            id: Date.now(),
            firstName: firstName,
            lastName: lastName,
            gender: entry.gender || '',
            dob: entry.date_of_birth || '',
            isOtpVerified: false,
            mobile: entry.phone_number || '',
            otp: ''
        };

        if (age >= 18) {
            setForms([filledData]);
        } else {
            setChildForms([filledData]);
        }
    };

    const [showIframe, setShowIframe] = useState(false);




    return (
        <div className="container mt-4">
            <ToastContainer />

            <div className="d-flex flex-row justify-content-between align-items-start">
                <div className="col-md-8">
                    <h4 className="mb-2">
                        <strong>Fill Waiver Form for trampoline and soft play</strong>
                    </h4>

                    <div className="mb-3" style={{ marginTop: "5px", marginBottom: "5px" }}>
                        <h6>Please fill the waiver for: {Waiverlength} people</h6>
                    </div>

                    <div className="d-flex gap-3 flex-wrap mb-3">
                        {options.map((label) => (
                            <button
                                key={label}
                                className={`waiver-btn ${selected === label ? 'selected' : ''}`}
                                onClick={() => handleSelect(label)}
                            >
                                <span className="ms-2" style={{ color: selected === label ? '#fff' : '#4D1C8D' }}>
                                    {label}
                                </span>
                                <input
                                    type="checkbox"
                                    checked={selected === label}
                                    readOnly
                                    className="rounded-checkbox"
                                    style={{ marginLeft: "10px" }}
                                />
                            </button>
                        ))}
                    </div>
                </div>
                <div
                    className="col-md-4 d-flex flex-column align-items-center"
                    style={{
                        marginRight: "65px"
                    }}
                >
                    <div
                        style={{
                            border: '2px dotted #4D1C8D',
                            width: '150px',
                            height: '150px',
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: '10px'
                        }}
                    >
                        <img
                            // src={require("../../assets/FRSPhotoIcon.png")}
                            alt="Photo Icon"
                            className="rounded"
                            style={{
                                width: '50px',
                                height: '50px'
                            }}
                        />
                    </div>

                    {/* <a
                        href="https://ypay-upload.s3.ap-south-1.amazonaws.com/waiverform.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'underline', color: '#4D1C8D', fontWeight: 'bold' }}
                    >
                        View Sample Waiver
                    </a> */}
                    <div>
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowIframe(true);
                            }}
                            style={{
                                textDecoration: 'underline',
                                color: '#4D1C8D',
                                fontWeight: 'bold',
                            }}
                        >
                            View Sample Waiver
                        </a>
{/* 
                        <IframeModal
                            show={showIframe}
                            onClose={() => setShowIframe(false)}
                            url="https://ypay-upload.s3.ap-south-1.amazonaws.com/waiverform.html"
                        /> */}
                    </div>
                </div>
            </div>

            {selected === 'Kids Only' && (
                <div className="col-md-5 mt-2">
                    <div className="card-body">
                        <div className="d-flex align-items-center gap-3 flex-wrap">
                            {/* Mobile Input */}
                            <div className="input-group" style={{ width: '240px' }}>
                                <span className="input-group-text">+91</span>
                                <input
                                    type="text"
                                    placeholder="Phone Number"
                                    className="form-control"
                                    maxLength={10}
                                    value={kidsOnlyParent.mobile}
                                    onChange={(e) =>
                                        handleKidsOnlyParentChange("mobile", e.target.value)
                                    }
                                />
                            </div>

                            <button
                                className="btn btn-secondary btn-sm"
                                style={{
                                    width: "120px",
                                    cursor:
                                        kidsOnlyParent.mobile.length !== 10 || !resendEnabled['kidsOnly']
                                            ? 'not-allowed'
                                            : 'pointer'
                                }}
                                disabled={
                                    kidsOnlyParent.mobile.length !== 10 || !resendEnabled['kidsOnly']
                                }
                                onClick={() => handleSendOtp(kidsOnlyParent.mobile, 'kidsOnly')}
                            >
                                {!otpSentStatus['kidsOnly']
                                    ? 'Send OTP'
                                    : resendEnabled['kidsOnly']
                                        ? 'Resend OTP'
                                        : `Wait ${otpTimers['kidsOnly'] || 0}s`}
                            </button>


                            {/* OTP Input */}
                            <input
                                type="text"
                                placeholder="Enter OTP"
                                className="form-control"
                                maxLength={6}
                                value={kidsOnlyParent.otp}
                                disabled={
                                    !kidsOnlyParent.mobile ||
                                    kidsOnlyParent?.mobile?.length < 10
                                }
                                onChange={(e) =>
                                    handleKidsOnlyParentChange("otp", e.target.value)
                                }
                                style={{ width: '200px' }}
                            />

                            {/* Verify Button */}
                            <button
                                className="btn btn-secondary btn-sm"
                                style={{
                                    width: "120px",
                                    cursor: kidsOnlyParent.otp.length < 6 ? 'not-allowed' : 'pointer'
                                }}
                                disabled={kidsOnlyParent.otp.length < 6 || kidsOnlyParent.isOtpVerified}
                                onClick={handleVerifyOtpForKidsOnly}
                            >
                                Verify OTP
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {showTable && (
                <div className="col-md-5">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6>Waiver Filled For {savedWaiver.length}</h6>
                    </div>
                    <table className="table table-bordered table-sm">
                        <thead className="table-light" style={{ textAlign: "center" }}>
                            <tr>
                                <th>Name</th>
                                <th>Age</th>
                                <th>Gender</th>
                                <th>Select</th>
                            </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                            {/* {waiverData.map((entry, index) => (
                                 */}
                            {savedWaiver.map((entry, index) => (

                                <tr key={index}>
                                    <td>{entry.name} {entry.lastName}</td>
                                    {/* <td>{entry.date_of_birth}</td> */}
                                    <td>{Math.floor((new Date() - new Date(entry.dob)) / (1000 * 60 * 60 * 24 * 365.25))}</td>
                                    <td>{entry.gender}</td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedWaiverEntry?.id === entry.id}
                                            onChange={() => handleCheckboxChange(entry)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>
            )}

            {(selected === 'Adult' || selected === 'Adult + Kids') && (
                <div className="col-md-11" style={{ marginTop: "20px" }}>
                    {forms.map((form, index) => {
                        const isMobileValid = form?.mobile?.length === 10;
                        const isResendAllowed = resendEnabled[form.id] ?? true;
                        const timer = otpTimers[form.id] || 0;

                        return (
                            <div key={form.id} className="card p-3 mb-3 shadow-sm">
                                <div className="row g-3 align-items-end">
                                    <div className="col-md-3">
                                        <div className="input-group">
                                            <span className="input-group-text">+91</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Phone"
                                                maxLength={10}
                                                value={form.mobile || ''}
                                                onChange={(e) => handleInputChange(form.id, "mobile", e.target.value)}
                                            />

                                        </div>
                                    </div>


                                    <div className="col-md-2  mb-1">
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            style={{
                                                width: "120px",
                                                cursor: isMobileValid && isResendAllowed ? 'pointer' : 'not-allowed',
                                            }}
                                            disabled={!isMobileValid || !isResendAllowed}
                                            onClick={() => handleSendOtp(form.mobile, form.id)}
                                        >
                                            {!otpSentStatus[form.id]
                                                ? 'Send OTP'
                                                : isResendAllowed
                                                    ? 'Resend OTP'
                                                    : `Wait ${timer}s`}
                                        </button>

                                    </div>

                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter OTP"
                                            maxLength={6}
                                            value={form.otp || ''}
                                            onChange={(e) => handleInputChange(form.id, "otp", e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2 mb-1">
                                        <button
                                            disabled={!form.otp || form.otp.length < 6}
                                            className="btn btn-secondary btn-sm" style={{ width: "120px" }}
                                            onClick={() => handleVerifyOtp(form.id, form.otp)}

                                        >
                                            Verify OTP
                                        </button>
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="First Name"
                                            value={form.firstName || ''}
                                            onChange={(e) => handleInputChange(form.id, "firstName", e.target.value)}
                                        />
                                        {errors[`firstName_${index}`] && (
                                            <span className="text-danger">{errors[`firstName_${index}`]}</span>
                                        )}
                                    </div>
                                    <div className="col-md-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Last Name"
                                            value={form.lastName || ''}
                                            onChange={(e) => handleInputChange(form.id, "lastName", e.target.value)}
                                        />
                                        {errors[`lastName_${index}`] && (
                                            <span className="text-danger">{errors[`lastName_${index}`]}</span>
                                        )}
                                    </div>
                                    <div className="col-md-3">
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={form.dob || ''}
                                            onChange={(e) => handleInputChange(form.id, "dob", e.target.value)}
                                        // max={get18YearsAgoDate()} 
                                        />
                                        {errors[`dob_${index}`] && (
                                            <span className="text-danger">{errors[`dob_${index}`]}</span>
                                        )}
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            value={form.gender || ''}
                                            onChange={(e) => handleInputChange(form.id, "gender", e.target.value)}
                                        >
                                            <option value="">Gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="other">Other</option>
                                        </select>
                                        {errors[`gender_${index}`] && (
                                            <span className="text-danger">{errors[`gender_${index}`]}</span>
                                        )}
                                    </div>
                                    <div className="col-md-1 mb-3 d-flex justify-content-center">
                                        <button className="btn btn-secondary btn-sm rounded-pill d-flex align-items-center gap-1">
                                            <div
                                                style={{
                                                    width: 20,
                                                    height: 20,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#fff',
                                                    color: '#4D1C8D',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    fontWeight: 'bold',
                                                    fontSize: 14,
                                                    textAlign: "center"
                                                }}
                                            >
                                                +
                                            </div>
                                            FRS
                                        </button>
                                    </div>
                                </div>


                                <div className="d-flex justify-content-between align-items-center mt-4">
                                    {selected === 'Adult + Kids' && (
                                        <button
                                            onClick={() => setShowChildModal(true)}
                                            //  onClick={() => setChildForms([...childForms, {}])}
                                            className="btn btn-outline btn-sm"
                                            style={{ borderRadius: '1px', fontWeight: 'bold', color: "#000", borderColor: "#000" }}
                                        >
                                            + Add Child
                                        </button>
                                    )}

                                    <button
                                        className="btn"
                                        onClick={() => selected === 'Adult + Kids' ? handleAdultKidSubmit() : handleSubmit()}
                                        style={{
                                            backgroundColor: 'orange',
                                            color: 'white',
                                            borderRadius: '0px',
                                            width: "100px",
                                        }}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                            // </div>
                        );
                    })}
                </div>
            )}

            {selected === 'Kids Only' && otpVerified && (

                <div className="col-md-11 mt-4">
                    {childForms.map((child, index) => (
                        <div className="row mt-2 align-items-end">
                            <div className="col-md-3 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="First Name"
                                    value={child.firstName || ''}
                                    onChange={(e) => handleChildInput(child.id, "firstName", e.target.value)}
                                />
                                <span className="text-danger" style={{ minHeight: '20px', display: 'block' }}>
                                    {childErrors[`firstName_${index}`] || ''}
                                </span>
                            </div>
                            <div className="col-md-3 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Last Name"
                                    value={child.lastName || ''}
                                    onChange={(e) => handleChildInput(child.id, "lastName", e.target.value)}
                                />
                                <span className="text-danger" style={{ minHeight: '18px', display: 'block' }}>
                                    {childErrors[`lastName_${index}`] || ''}
                                </span>
                            </div>
                            <div className="col-md-3 mb-3">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={child.dob || ''}
                                    onChange={(e) => handleChildInput(child.id, "dob", e.target.value)}
                                    // min={get18YearsAgoDate()}
                                    max={getTodayDate()}
                                />
                                <span className="text-danger" style={{ minHeight: '18px', display: 'block' }}>
                                    {childErrors[`dob_${index}`] || ''}
                                </span>
                            </div>
                            <div className="col-md-2 mb-3">
                                <select
                                    className="form-select"
                                    value={child.gender || ''}
                                    onChange={(e) => handleChildInput(child.id, "gender", e.target.value)}
                                >
                                    <option value="">Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="other">Other</option>
                                </select>
                                <span className="text-danger" style={{ minHeight: '18px', display: 'block' }}>
                                    {childErrors[`gender_${index}`] || ''}
                                </span>
                            </div>
                            <div className="col-md-1 mb-5 d-flex justify-content-center">
                                <button className="btn btn-secondary btn-sm rounded-pill d-flex align-items-center gap-1">
                                    <div
                                        style={{
                                            width: 20,
                                            height: 20,
                                            borderRadius: '50%',
                                            backgroundColor: '#fff',
                                            color: '#4D1C8D',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            fontWeight: 'bold',
                                            fontSize: 14,
                                        }}>
                                        +
                                    </div>
                                    FRS
                                </button>
                            </div>
                        </div>
                    ))}

                    <div className="d-flex justify-content-between align-items-center mt-2">
                        {/* {selected === 'Adult + Kids' && ( */}
                        <button onClick={handleAddChildRow}
                            className="btn btn-outline btn-sm"
                            style={{
                                borderRadius: '1px',
                                fontWeight: 'bold',
                                color: "#000",
                                borderColor: "#000"
                            }}
                        >
                            + Add Child
                        </button>
                        {/* )} */}
                        <button
                            className="btn"
                            onClick={handleKidsSubmit}
                            style={{
                                backgroundColor: 'orange',
                                color: 'white',
                                borderRadius: '0px',
                                width: "100px"
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            )}

            {showChildModal && (
                <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog" style={{ maxWidth: "900px", }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h7 className="modal-title">Fill Waiver for your child</h7>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowChildModal(false)}></button>
                            </div>

                            <div className="modal-body">
                                {childForms.map((child, index) => (
                                    <div className="row mt-2 align-items-end">
                                        <div className="col-md-3 mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="First Name"
                                                value={child.firstName || ''}
                                                onChange={(e) => handleChildInput(child.id, "firstName", e.target.value)}
                                            />
                                            <span className="text-danger" style={{ minHeight: '20px', display: 'block' }}>
                                                {childErrors[`firstName_${index}`] || ''}
                                            </span>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Last Name"
                                                value={child.lastName || ''}
                                                onChange={(e) => handleChildInput(child.id, "lastName", e.target.value)}
                                            />
                                            <span className="text-danger" style={{ minHeight: '18px', display: 'block' }}>
                                                {childErrors[`lastName_${index}`] || ''}
                                            </span>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={child.dob || ''}
                                                onChange={(e) => handleChildInput(child.id, "dob", e.target.value)}
                                                // min={get18YearsAgoDate()}
                                                max={getTodayDate()}
                                            />
                                            <span className="text-danger" style={{ minHeight: '18px', display: 'block' }}>
                                                {childErrors[`dob_${index}`] || ''}
                                            </span>
                                        </div>
                                        <div className="col-md-2 mb-3">
                                            <select
                                                className="form-control"
                                                value={child.gender || ''}
                                                onChange={(e) => handleChildInput(child.id, "gender", e.target.value)}
                                            >
                                                <option value="">Gender</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                                <option value="other">Other</option>
                                            </select>
                                            <span className="text-danger" style={{ minHeight: '18px', display: 'block' }}>
                                                {childErrors[`gender_${index}`] || ''}
                                            </span>
                                        </div>
                                        <div className="col-md-1 mb-3 d-flex justify-content-center">
                                            <button className="btn btn-secondary btn-sm rounded-pill d-flex align-items-center gap-1">
                                                <div
                                                    style={{
                                                        width: 20,
                                                        height: 20,
                                                        borderRadius: '50%',
                                                        backgroundColor: '#fff',
                                                        color: '#4D1C8D',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        fontWeight: 'bold',
                                                        fontSize: 14,
                                                    }}>
                                                    +
                                                </div>
                                                FRS
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                <div className="d-flex justify-content-between align-items-center mt-4">
                                    {/* {selected === 'Adult + Kids' && ( */}
                                    <button
                                        onClick={handleAddChildRow}
                                        className="btn btn-outline btn-sm"
                                        style={{
                                            borderRadius: '1px',
                                            fontWeight: 'bold',
                                            color: "#000",
                                            borderColor: "#000"
                                        }}
                                    >
                                        + Add Child
                                    </button>
                                    {/* )} */}
                                    <button
                                        className="btn"
                                        disabled={!childForms}
                                        onClick={() => {
                                            const isValid = validateFormFields();
                                            if (isValid) {
                                                setShowChildModal(false);
                                            }
                                        }}
                                        style={{
                                            backgroundColor: childForms ? 'orange' : '#ccc',
                                            color: 'white',
                                            borderRadius: '0px',
                                            width: "100px",
                                            cursor: childForms ? 'pointer' : 'not-allowed'
                                        }}
                                    >
                                        Proceed
                                    </button>

                                </div>
                            </div>

                            {/* <div className="modal-footer">
                                <button className="btn btn-primary">Save</button>
                            </div> */}
                        </div>
                    </div>
                </div>
            )}
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "15px",
                    marginRight: "100px",
                    marginTop: "20px"
                }}
            >

                <button
                    className="btn"
                    disabled={enable} // ✅ Enable only when condition is met
                    onClick={() => window.location.reload()} // ✅ Reload on click
                    style={{
                        backgroundColor: 'orange',
                        color: 'white',
                        borderRadius: '0px',
                        width: "150px",
                        //cursor: enable ? 'pointer' : 'not-allowed'
                    }}
                >
                    Final Submit
                </button>
            </div>

        </div>

    );
};

export default AddWaiver;
